import { render } from "./DownloadMenu.vue?vue&type=template&id=7fa3c746&scoped=true&ts=true"
import script from "./DownloadMenu.vue?vue&type=script&lang=ts"
export * from "./DownloadMenu.vue?vue&type=script&lang=ts"

import "./DownloadMenu.vue?vue&type=style&index=0&id=7fa3c746&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa3c746"]])

export default __exports__